import React from 'react';

const BLOCKED_IMAGE_HOST_PATTERNS = [
  'fbcdn.net',
  'cdninstagram.com',
];

export const isBlockedExternalImageUrl = (url?: string | null): boolean => {
  if (!url) return false;
  return BLOCKED_IMAGE_HOST_PATTERNS.some((pattern) => url.includes(pattern));
};

export const resolveImageUrl = (url: string | null | undefined, fallback: string): string => {
  if (!url) return fallback;
  if (isBlockedExternalImageUrl(url)) return fallback;
  return url;
};

export const withImageFallback = (
  event: React.SyntheticEvent<HTMLImageElement>,
  fallback: string
): void => {
  const image = event.currentTarget;
  if (image.dataset.fallbackApplied === 'true') {
    return;
  }

  image.dataset.fallbackApplied = 'true';
  image.onerror = null;
  image.src = fallback;
};